var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-crop',{attrs:{"width":_vm.width,"height":_vm.height,"field":_vm.fileName,"noRotate":false,"img-format":"png"},on:{"crop-upload-success":_vm.uploadSuccess,"crop-success":_vm.cropSuccess,"crop-upload-fail":_vm.cropUploadFail},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79cd4060","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CropUpload.vue
// module id = null
// module chunks = 